export default "__VITE_ASSET__VJb84EGa__"